module.exports = __webpack_public_path__ + "static/media/Bluelab IntelliDose Controller Kit.050e2913.webp";